module.exports = __webpack_public_path__ + "img/upload.434d9c90.svg";